import { Modal } from '@arco-design/web-vue'
import VipDialog from '~/components/user/vip/Dialog.vue'

export function useVipModal() {
  let open = false
  function closeModal() {
    open = false
  }
  const localePath = useLocalePath()
  const { isSubAccount, isLogin } = useLogin()
  return {
    open: (type: number, resource: number) => {
      if (isSubAccount.value)
        return
      if (resource === 3) {
        return navigateTo(localePath('/analysis/products'))
      }
      const offlineModal = Modal.open({
        footer: false,
        maskClosable: false,
        hideTitle: true,
        // hideCancel: true,
        width: 840,
        skip: isLogin.value,
        bodyStyle: { padding: '0' },
        content: () => h(
          VipDialog,
          {
            type,
            resource,
            visible: open,
            onOk: () => {
              closeModal()
              offlineModal.close()
            },
          },
        ),
        onCancel: () => {
          closeModal()
          offlineModal.close()
        },
      })
      open = true
    },
  }
}
